import { getNextApiRoute, typedFetch } from '@libs/common-next';
import { HttpMethod } from '@libs/core';

export const getAutoshipSubscriptions = async () => {
    return typedFetch<{ count: number }>(getNextApiRoute('autoship/subscriptions'), {
        method: HttpMethod.GET,
        headers: {
            'content-type': 'application/json',
        },
    });
};
